export interface IWorkReport {
    Id: string;
    Created: string;
    JobNumber: string;
    IsSigned: boolean;
    SignedDate: string | null;
    SigneeName: string | null;
    SignatureId: string | null;
    Details: string | null;
    SatisfactionRating: SatisfactionRating;
}

export enum SatisfactionRating {
    undefined = -1,
    UnHappy = 0, 
    InDifferent = 1, 
    Happy = 2
}